// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UofF","placeholdersHeader":"styles_placeholdersHeader__1N8wZ","editorStyle":"styles_editorStyle__t5SPN","placeholdersBox":"styles_placeholdersBox__1DrPy"};